import React from 'react'
import { cn } from '@/lib/utils'

// Re-export Radix UI Select components for performance components
// Export the Radix Select as the default "Select" export
export {
  Select,  // This is the Radix UI Select root component
  SelectValue,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectGroup,
  SelectLabel,
  SelectSeparator,
} from './select-radix'

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: string
  label?: string
  onValueChange?: (value: string) => void
  children: React.ReactNode
}

// Legacy HTML select component (renamed to avoid conflicts)
export function HTMLSelect({
  className,
  error,
  label,
  id,
  onValueChange,
  onChange,
  children,
  ...props
}: SelectProps) {
  const selectId = id || `select-${Math.random().toString(36).substr(2, 9)}`

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange?.(e)
    onValueChange?.(e.target.value)
  }

  return (
    <div className="space-y-2">
      {label && (
        <label htmlFor={selectId} className="block text-sm font-medium text-brand-gray">
          {label}
        </label>
      )}
      <select
        id={selectId}
        className={cn(
          'form-select w-full px-3 py-2 border border-brand-gray/30 rounded-monumenta-sm',
          'bg-brand-dark-lighter text-white',
          'focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary',
          'hover:border-brand-gray/50 transition-colors duration-200',
          error && 'border-error focus:ring-error focus:border-error',
          className
        )}
        onChange={handleChange}
        {...props}
      >
        {children}
      </select>
      {error && (
        <p className="text-error text-sm">{error}</p>
      )}
    </div>
  )
}